module.exports = __webpack_public_path__ + "60708c3c618ba457bc35af613ce97887.pdf";